import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  goBackFromSocialAct,
} from 'actions/storylet';

import RenameComponent from './RenameComponent';

class RenameContainer extends Component {
  /**
   * Go Back
   * @return {undefined}
   */
  handleGoBack = () => {
    const { dispatch } = this.props;
    dispatch(goBackFromSocialAct());
  }

  /**
   * Render
   * @return {Object}
   */
  render() {
    const { branch, qualities } = this.props;
    return (
      <RenameComponent
        branch={branch}
        qualities={qualities}
        onGoBack={this.handleGoBack}
      />
    );
  }
}

RenameContainer.displayName = 'RenameContainer';

RenameContainer.propTypes = {
  branch: PropTypes.shape({}).isRequired,
  dispatch: PropTypes.func.isRequired,
  qualities: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

const mapStateToProps = ({
  storylet: {
    rename: {
      branch,
      namableQualitiesPossessed: qualities,
    },
  },
}) => ({
  branch,
  qualities,
});

export default withRouter(connect(mapStateToProps)(RenameContainer));
